var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0823 0.500014H9.78508C9.29245 0.498668 8.80445 0.591209 8.34935 0.772273C7.89426 0.953338 7.48113 1.21932 7.13391 1.55481L3.59901 4.94841C3.2494 5.28189 2.97225 5.67871 2.78365 6.11583C2.59504 6.55295 2.49872 7.02167 2.50029 7.49481V22.1C2.49026 22.7258 2.7391 23.3298 3.19227 23.7797C3.64543 24.2296 4.26593 24.4886 4.91772 24.5H20.0823C20.7341 24.4886 21.3546 24.2296 21.8077 23.7797C22.2609 23.3298 22.5097 22.7258 22.4997 22.1V2.90001C22.5097 2.27425 22.2609 1.6702 21.8077 1.2203C21.3546 0.770403 20.7341 0.511377 20.0823 0.500014ZM8.75011 3.39681V6.50001H5.5177L8.75011 3.39681ZM5.00022 22.1V8.90001H8.75011C9.41313 8.90001 10.049 8.64715 10.5178 8.19707C10.9867 7.74698 11.25 7.13653 11.25 6.50001V2.90001L19.9923 2.87361C19.9974 2.88153 20 2.8907 19.9998 2.90001L20.0823 22.1H5.00022Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.f59505c667f41b217eb2bc9c8dcba6e7.svg";
export { ForwardRef as ReactComponent };